import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import readArgee from '@/views/readArgee.vue'
import privateRules from '@/views/privateRules.vue'
import page404 from '@/views/404.vue'




Vue.use(Router)

export default new Router({
  // mode: 'hash',
  mode: "history",
  "base": process.env.VUE_APP_NODE_DEV === 'pre-production' ? '/sem/' : '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/argee',
      name: 'argee',
      component: readArgee
    },
    {
      path: '/privateRules',
      name: 'privateRules',
      component: privateRules
    },
    {
      path: '/404',
      name: '404',
      component: page404
    },
    { path: '*', redirect: '/404', hidden: true, },
  ]
})
